// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { HttpMethodSchema } from '../inputTypeSchemas/HttpMethodSchema'
import { BodyTypeSchema } from '../inputTypeSchemas/BodyTypeSchema'

/////////////////////////////////////////
// HTTP REQUEST SCHEMA
/////////////////////////////////////////

export const HttpRequestSchema = z.object({
  method: HttpMethodSchema,
  bodyType: BodyTypeSchema,
  pathParams: z.string().array(),
  bodySchema: z.string().nullable(),
})

export type HttpRequest = z.infer<typeof HttpRequestSchema>

export default HttpRequestSchema;
